module.exports = __webpack_public_path__ + "img/google_logo.113869dd.png";